import React from 'react';
import './HeroMarketBanner.css';

const regimeColors = {
  ALTSEASON: { bg: 'linear-gradient(90deg, #7b2ff2 0%, #00c6ff 100%)', badge: '#7b2ff2' },
  DEFENSIF: { bg: 'linear-gradient(90deg, #ff5858 0%, #f09819 100%)', badge: '#ff5858' },
  DEFENSIVE: { bg: 'linear-gradient(90deg, #ff5858 0%, #f09819 100%)', badge: '#ff5858' },
  ROTATION_ETH: { bg: 'linear-gradient(90deg, #2193b0 0%, #6dd5ed 100%)', badge: '#2193b0' },
  NEUTRE: { bg: 'linear-gradient(90deg, #757f9a 0%, #d7dde8 100%)', badge: '#757f9a' },
  NEUTRAL: { bg: 'linear-gradient(90deg, #757f9a 0%, #d7dde8 100%)', badge: '#757f9a' },
  BTC_DOMINANCE_UP: { bg: 'linear-gradient(90deg, #d1913c 0%, #ffd194 100%)', badge: '#d1913c' },
  BITCOIN_DOMINANT: { bg: 'linear-gradient(90deg, #d1913c 0%, #ffd194 100%)', badge: '#d1913c' },
  ETH_ROTATION: { bg: 'linear-gradient(90deg, #2193b0 0%, #6dd5ed 100%)', badge: '#2193b0' },
};

const regimeLabels = {
  ALTSEASON: 'Altseason',
  DEFENSIF: 'Défensif',
  DEFENSIVE: 'Défensif',
  ROTATION_ETH: 'Rotation ETH',
  NEUTRE: 'Neutre',
  NEUTRAL: 'Neutre',
  BTC_DOMINANCE_UP: 'BTC Dominance ↑',
  BITCOIN_DOMINANT: 'BTC Dominance ↑',
  ETH_ROTATION: 'ETH Rotation',
};

const HeroBanner = ({
  regime,
  marketLabel = 'Marché Crypto',
  marketCap,
  marketChange24h,
  sentiment,
  btcDominance,
  ethDominance,
  regimeConfidence,
  macroScore,
  lastUpdate,
}) => {
  const colors = regimeColors[regime] || regimeColors.NEUTRE;
  const marketCapValue = Number.isFinite(Number(marketCap)) ? Number(marketCap) : null;
  const regimeLabel = regime || 'N/A';
  const formattedLastUpdate = lastUpdate ? new Date(lastUpdate).toLocaleString('fr-FR') : 'N/A';
  const heroHighlights = [
    `Régime ${regimeLabels[regimeLabel] || regimeLabel}`,
    `Sentiment ${sentiment != null ? `${Math.round(Number(sentiment))}/100` : 'N/A'}`,
    `Macro ${macroScore != null ? Number(macroScore).toFixed(2) : 'N/A'}`,
  ];

  return (
    <div className="hero-market-banner" style={{ background: colors.bg }}>
      <div className="hero-market-content">
        <div className="hero-market-label">
          <div className="hero-market-heading-block">
            <span className="hero-market-title">{marketLabel}</span>
            <p className="hero-market-subtitle">
              Vue macro priorisée pour savoir ce que le marché rémunère, ce qu’il sanctionne et si le terrain mérite d’ouvrir le risque.
            </p>
          </div>
          <div className="hero-market-sidecar">
            <span className="hero-market-change">
              {marketChange24h !== undefined && marketChange24h !== null ? (marketChange24h >= 0 ? '▲' : '▼') : ''}
              {marketChange24h !== undefined && marketChange24h !== null ? `${Math.abs(Number(marketChange24h)).toFixed(2)}% (24h)` : ''}
            </span>
            <span className="hero-market-update">Sync {formattedLastUpdate}</span>
          </div>
        </div>
        <div className="hero-market-highlights">
          {heroHighlights.map((item) => (
            <span key={item} className="hero-market-highlight">{item}</span>
          ))}
        </div>
        <div className="hero-market-metrics">
          <div className="hero-market-metric">
            <span className="metric-label">Capitalisation</span>
            <span className="metric-value">{marketCapValue !== null ? marketCapValue.toLocaleString('fr-FR', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }) : 'N/A'}</span>
          </div>
          <div className="hero-market-metric">
            <span className="metric-label">BTC Dominance</span>
            <span className="metric-value">{btcDominance != null ? `${Number(btcDominance).toFixed(2)}%` : 'N/A'}</span>
          </div>
          <div className="hero-market-metric">
            <span className="metric-label">ETH Dominance</span>
            <span className="metric-value">{ethDominance != null ? `${Number(ethDominance).toFixed(2)}%` : 'N/A'}</span>
          </div>
          <div className="hero-market-metric">
            <span className="metric-label">Fear & Greed Index</span>
            <span className="metric-value">{sentiment != null ? `${Math.round(Number(sentiment))} / 100` : 'N/A'}</span>
          </div>
          <div className="hero-market-metric">
            <span className="metric-label">Régime</span>
            <span className="metric-value" style={{ background: colors.badge, color: '#fff', borderRadius: 8, padding: '2px 8px' }}>
              {regimeLabels[regimeLabel] || regimeLabel} {regimeConfidence != null ? `(${(Number(regimeConfidence) * 100).toFixed(0)}%)` : ''}
            </span>
          </div>
          <div className="hero-market-metric">
            <span className="metric-label">Macro Score</span>
            <span className="metric-value">{macroScore != null ? Number(macroScore).toFixed(2) : 'N/A'}</span>
          </div>
          <div className="hero-market-metric">
            <span className="metric-label">Dernière mise à jour</span>
            <span className="metric-value">{formattedLastUpdate}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroBanner;
